import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classNames from 'classnames'
import { SchemaBranchMixin } from 'legacy/libs/baobab-react-mixins'
import BaobabPropTypes from 'legacy/libs/baobab-prop-types'
import { ValidationBox, ValidationError } from 'legacy/libs/react-form-tools'
import entryTagApi from 'legacy/api/entry-tag'
import { GroupSelect, SelectedTags } from 'legacy/libs/components/tags'
import Sticky from 'legacy/libs/components/sticky-block'
import createReactClass from 'create-react-class'
import { GetText } from 'lib/gettext'

import ss from '../second-step.module.scss'
import s from './entry-tags.module.scss'

export default createReactClass({
  displayName: 'EntryTags',

  mixins: [SchemaBranchMixin],

  propTypes: {
    tree: BaobabPropTypes.baobab.isRequired,
    stepCollapsed: PropTypes.bool,
    poll: PropTypes.object,
  },

  schema: {
    entryTags: [],
    pollEntryTagGroups: [],
  },

  cursors(props) {
    return {
      rootEntryTags: props.rootEntryTagsCursor,
      entryTagGroups: props.entryTagGroupsCursor,
    }
  },

  UNSAFE_componentWillMount() {
    this.buildPollEntryTagGroups()
  },

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.poll.pk !== this.props.poll.pk) {
      this.cursors.entryTags.set([])
      this.buildPollEntryTagGroups()
    }
  },

  buildPollEntryTagGroups() {
    const entryTagGroups = _.filter(
      this.state.entryTagGroups,
      (group) =>
        _.includes(this.props.poll.requiredEntryTagGroups, group.pk) ||
        _.includes(this.props.poll.optionalEntryTagGroups, group.pk)
    )

    const preparedEntryTagGroups = _.orderBy(
      _.map(entryTagGroups, (group) => {
        const groupRootEntryTags = _.filter(
          this.cursors.rootEntryTags.get(),
          (rootEntryTag) => rootEntryTag.entryTagGroup === group.pk
        )

        const isRequired = _.includes(
          this.props.poll.requiredEntryTagGroups,
          group.pk
        )

        return {
          ...group,
          required: isRequired,
          rootEntryTags: _.map(groupRootEntryTags, (tag) => ({
            ...tag,
            isRequiredTagGroup: isRequired,
          })),
        }
      }),
      (group) => group.required,
      'desc'
    )

    this.cursors.pollEntryTagGroups.set(preparedEntryTagGroups)
  },

  getEntryTags(parentTagPk) {
    return entryTagApi.getList({ parent: parentTagPk })
  },

  render() {
    const { poll, stepCollapsed } = this.props
    const { entryTags } = this.state

    return (
      <ValidationBox
        className={classNames('validationbox', s.container)}
        fieldPath="entryTags"
      >
        <ValidationError className={s.error} fieldPath="entryTags" />
        <div
          className={s.content}
          ref={(ref) => {
            this.content = ref
          }}
        >
          <div className={classNames(s.col, s._left)}>
            <div className={s.title}>
              <GetText>Available tags:</GetText>
            </div>
            <div className={ss.instructions}>
              <GetText>
                Add at least one tag from each required tag tree.
              </GetText>
            </div>
            {this.cursors.pollEntryTagGroups.map((groupCursor, index) => (
              <GroupSelect
                tree={groupCursor}
                poll={poll}
                service={this.getEntryTags}
                rootEntryTagsCursor={groupCursor.select('rootEntryTags')}
                createService={entryTagApi.create}
                deleteService={entryTagApi.delete}
                approveService={entryTagApi.approve}
                refuseService={entryTagApi.refuse}
                key={index}
              />
            ))}
          </div>
          <div className={s.col}>
            <div className={s.wrapper}>
              {!stepCollapsed ? (
                <Sticky
                  stickToBottom
                  parent={this.content}
                  stickyOnlyIfBiggerThanWindow
                >
                  <div className={s.selected__tags}>
                    <div className={s.title}>
                      <GetText>Added tags</GetText>
                    </div>
                    {entryTags.length ? null : (
                      <div>
                        <div className={ss.instructions}>
                          <GetText>No tags added yet.</GetText>
                        </div>
                        <div className={ss.instructions}>
                          <GetText>
                            To add organizational tags to your group, click
                            through the categories in the tree on the left that
                            are associated with your group.
                          </GetText>
                        </div>
                      </div>
                    )}
                    <SelectedTags
                      approveService={entryTagApi.approve}
                      refuseService={entryTagApi.refuse}
                      groupsCursor={this.cursors.entryTagGroups}
                    />
                  </div>
                </Sticky>
              ) : null}
            </div>
          </div>
        </div>
      </ValidationBox>
    )
  },
})
